/* eslint-disable react-hooks/rules-of-hooks */
import {
  EditOutlined,
  ExportOutlined,
  PrinterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Space,
  Table,
  Tooltip,
  notification,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import excel from "xlsx";
import "./style.css";

import { Env, PrintFonts } from "../../../../styles";

/** يجب أن يطابق رقم نوع الإجازة في طلب التقرير get-annualy-tasks-report/{vac_id}/... */
const ANNUAL_REPORT_VAC_ID = 2;

export default function AnnualReport(props) {
  const [sortedInfo, setSortedInfo] = useState({});
  const [filteredInfo, setFilteredInfo] = useState({});
  const [load, setLoad] = useState(true);
  const [loadReport] = useState(false);
  const [namesFilter, setNamesFilter] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().format("YYYY"));
  const [categories, setCategories] = useState([]);
  const [annTasks, setAnnTasks] = useState([]);
  const [pannTasks, setPAnnTasks] = useState([]);
  const [resettingUserId, setResettingUserId] = useState(null);
  const [editingRow, setEditingRow] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isSavingEdit, setIsSavingEdit] = useState(false);
  const [editForm] = Form.useForm();

  const toMinutesNumber = (valueInMinutes) => {
    const safeValue = Number(valueInMinutes || 0);
    if (!Number.isFinite(safeValue)) return 0;
    return Math.max(0, Math.round(safeValue));
  };

  const openEditAnnualRowModal = (record) => {
    setEditingRow(record);
    editForm.setFieldsValue({
      prev: toMinutesNumber(record.prev),
      curr: toMinutesNumber(record.curr),
      trans: toMinutesNumber(record.trans),
      m1: toMinutesNumber((record.m1 || 0) / 60),
      m2: toMinutesNumber((record.m2 || 0) / 60),
      m3: toMinutesNumber((record.m3 || 0) / 60),
      m4: toMinutesNumber((record.m4 || 0) / 60),
      m5: toMinutesNumber((record.m5 || 0) / 60),
      m6: toMinutesNumber((record.m6 || 0) / 60),
      m7: toMinutesNumber((record.m7 || 0) / 60),
      m8: toMinutesNumber((record.m8 || 0) / 60),
      m9: toMinutesNumber((record.m9 || 0) / 60),
      m10: toMinutesNumber((record.m10 || 0) / 60),
      m11: toMinutesNumber((record.m11 || 0) / 60),
      m12: toMinutesNumber((record.m12 || 0) / 60),
    });
    setIsEditModalOpen(true);
  };

  const closeEditAnnualRowModal = () => {
    setIsEditModalOpen(false);
    setEditingRow(null);
    editForm.resetFields();
  };

  const handleSaveAnnualRowEdit = async () => {
    if (!editingRow) return;
    try {
      const values = await editForm.validateFields();
      const payload = {
        user_id: Number(editingRow.user_id),
        year: parseInt(currentYear, 10),
        vac_id: ANNUAL_REPORT_VAC_ID,
        prev: toMinutesNumber(values.prev),
        curr: toMinutesNumber(values.curr),
        trans: toMinutesNumber(values.trans),
        months: Array.from({ length: 12 }, (_, index) =>
          toMinutesNumber(values[`m${index + 1}`])
        ),
      };

      setIsSavingEdit(true);
      const res = await axios.post(
        Env.HOST_SERVER_NAME + "update-user-annual-tasks-report",
        payload
      );

      if (res.data?.success) {
        notification.success({
          message: res.data.message || "تم تحديث التقرير السنوي",
          placement: "bottomLeft",
        });
        closeEditAnnualRowModal();
        fetchAnnualReportData();
      } else {
        notification.error({
          message: "فشل التحديث",
          description: res.data?.message || "حدث خطأ غير متوقع",
          placement: "bottomLeft",
        });
      }
    } catch (error) {
      if (error?.errorFields) return;
      notification.error({
        message: "فشل التحديث",
        description:
          error.response?.data?.message || "تعذر الاتصال بالخادم أثناء الحفظ",
        placement: "bottomLeft",
        duration: 10,
      });
    } finally {
      setIsSavingEdit(false);
    }
  };

  const fetchAnnualReportData = useCallback(() => {
    setLoad(true);

    axios
      .get(Env.HOST_SERVER_NAME + "get-rest-tasks/" + currentYear)
      .then((response) => {
        setCategories(response.data.categories);
      })
      .catch(function (error) {
        console.log(error);
      });

    axios
      .get(
        Env.HOST_SERVER_NAME +
          "get-annualy-tasks-report/" +
          ANNUAL_REPORT_VAC_ID +
          "/" +
          currentYear
      )
      .then((response) => {
        setAnnTasks(response.data);
        setPAnnTasks(response.data);

        let annualNames = [];
        response.data.forEach((element) => {
          if (!annualNames.some((item) => element.name === item.text))
            annualNames.push({
              text: element["name"],
              value: element["name"],
            });
        });
        annualNames = annualNames.sort((a, b) => a.text.localeCompare(b.text));
        const annualNamesWithSelectAll = [
          { text: "تحديد الكل", value: "SELECT_ALL_NAMES" },
          ...annualNames,
        ];
        setNamesFilter(annualNamesWithSelectAll);
        setLoad(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoad(false);
      });
  }, [currentYear]);

  const handleResetUserAnnualRow = (userId, employeeName) => {
    Modal.confirm({
      title: "تصفير صف التقرير السنوي للموظف",
      content: (
        <div>
          <p>
            سيتم حذف{" "}
            <strong>أرصدة نوع الإجازة المعروض في هذا التقرير</strong> و{" "}
            <strong>كل الاستهلاك المسجل في أعمدة الأشهر</strong> للموظف:{" "}
            <strong>{employeeName}</strong> لسنة <strong>{currentYear}</strong>.
          </p>
          <p style={{ color: "#cf1322", marginBottom: 0 }}>
            لا يمكن التراجع. إن لم يبقَ للموظف رصيد لهذا النوع قد يختفي الصف من
            الجدول حتى تُضاف أرصدة جديدة.
          </p>
        </div>
      ),
      okText: "تصفير",
      cancelText: "إلغاء",
      okType: "danger",
      width: 480,
      onOk: async () => {
        setResettingUserId(userId);
        try {
          const res = await axios.post(
            Env.HOST_SERVER_NAME + "reset-user-annual-tasks-report",
            {
              user_id: Number(userId),
              year: parseInt(currentYear, 10),
              vac_id: ANNUAL_REPORT_VAC_ID,
            }
          );
          if (res.data?.success) {
            notification.success({
              message: res.data.message || "تم التصفير",
              description: `سجلات الرصيد: ${res.data.deleted_vacations_users ?? 0}، سجلات الاستهلاك: ${res.data.deleted_attendancelogs ?? 0}`,
              placement: "bottomLeft",
              duration: 8,
            });
            fetchAnnualReportData();
          } else {
            notification.error({
              message: "فشل التصفير",
              description: res.data?.message || "حدث خطأ",
              placement: "bottomLeft",
              duration: 8,
            });
          }
        } catch (error) {
          notification.error({
            message: "فشل التصفير",
            description:
              error.response?.data?.message ||
              "تعذر الاتصال بالخادم. تحقق من تحديث الباك اند.",
            placement: "bottomLeft",
            duration: 10,
          });
        } finally {
          setResettingUserId(null);
        }
      },
    });
  };

  const getColumnsVac = () => {
    const months = [
      "يناير",
      "فبراير",
      "مارس",
      "إبريل",
      "مايو",
      "يونيو",
      "يوليو",
      "أغسطس",
      "سبتمبر",
      "أكتوبر",
      "نوفمبر",
      "ديسمبر",
    ];

    const ncolumns = [
      {
        title: "م",
        dataIndex: "index",
        key: "index",
        width: 50,
        render: (text, record, index) => index + 1,
      },
      {
        title: "اسم الموظف",
        dataIndex: "name",
        key: "name",
        width: 200,
        ellipsis: false,
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <NamesFilterDropdown
            setSelectedKeys={setSelectedKeys}
            selectedKeys={selectedKeys}
            confirm={confirm}
            clearFilters={clearFilters}
          />
        ),
        onFilter: (value, record) => {
          if (value === "SELECT_ALL_NAMES") {
            return true; // Show all records when "Select All" is selected
          }
          return record.name?.includes(value);
        },
        filteredValue: filteredInfo.name || null,
        render: (text) => (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
              padding: "4px 0",
            }}
          >
            {text}
          </div>
        ),
      },
      {
        title: "الوظيفة",
        dataIndex: "job",
        key: "job",
        width: 150,
        ellipsis: true,
      },
      {
        title: "مرحل من العام الماضي",
        dataIndex: "prev",
        key: "prev",
        width: 120,
        render: (value) => {
          if (!value) return "0:00";
          return parseInt(value / 60) + ":" + Math.round(value % 60);
        },
      },
      {
        title: "رصيد العام الحالي",
        dataIndex: "curr",
        key: "curr",
        width: 120,
        render: (value) => {
          if (!value) return "0:00";
          return parseInt(value / 60) + ":" + Math.round(value % 60);
        },
      },
      {
        title: "رصيد محول",
        dataIndex: "trans",
        key: "trans",
        width: 100,
        render: (value) => {
          if (!value) return "0:00";
          return parseInt(value / 60) + ":" + Math.round(value % 60);
        },
      },
      {
        title: "الافتتاحي",
        dataIndex: "opening",
        key: "opening",
        width: 100,
        render: (text, record) => {
          const op =
            Math.round(record.prev || 0) +
            Math.round(record.curr || 0) +
            Math.round(record.trans || 0);
          return parseInt(op / 60) + ":" + (op % 60);
        },
      },
    ];

    // إضافة أعمدة الأشهر
    months.forEach((month, index) => {
      ncolumns.push({
        title: month,
        dataIndex: `m${index + 1}`,
        key: `m${index + 1}`,
        width: 80,
        render: (value) => {
          if (!value) return "0:00";
          const min = value / 60;
          return parseInt(min / 60) + ":" + (min % 60);
        },
      });
    });

    // إضافة العمودين الأخيرين
    ncolumns.push({
      title: "الممنوح",
      dataIndex: "granted",
      key: "granted",
      width: 100,
      render: (text, record) => {
        let totalg = 0;
        for (let i = 1; i <= 12; i++) {
          totalg += (record[`m${i}`] || 0) / 60;
        }
        return Math.round((totalg / 60 / 7) * 100) / 100;
      },
    });

    ncolumns.push({
      title: "المتبقي",
      dataIndex: "remaining",
      key: "remaining",
      width: 100,
      render: (text, record) => {
        const op =
          Math.round(record.prev || 0) +
          Math.round(record.curr || 0) +
          Math.round(record.trans || 0);
        let totalg = 0;
        for (let i = 1; i <= 12; i++) {
          totalg += (record[`m${i}`] || 0) / 60;
        }
        return Math.round(((op - totalg) / 60 / 7) * 100) / 100;
      },
    });

    ncolumns.push({
      title: "تعديل",
      key: "edit_annual_row",
      width: 88,
      fixed: "right",
      render: (_, record) => (
        <Tooltip title={`تعديل جميع حقول صف ${record.name || "الموظف"}`}>
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            onClick={() => openEditAnnualRowModal(record)}
            aria-label="تعديل صف التقرير السنوي للموظف"
          />
        </Tooltip>
      ),
    });

    ncolumns.push({
      title: "تصفير",
      key: "reset_annual_row",
      width: 88,
      fixed: "right",
      render: (_, record) => (
        <Tooltip
          title={`تصفير أرصدة واستهلاك هذا الموظف في التقرير (نوع الإجازة ${ANNUAL_REPORT_VAC_ID}) لسنة ${currentYear}`}
        >
          <Button
            danger
            type="default"
            shape="circle"
            icon={<ReloadOutlined />}
            loading={resettingUserId === record.user_id}
            onClick={() =>
              handleResetUserAnnualRow(record.user_id, record.name || "")
            }
            aria-label="تصفير صف التقرير السنوي للموظف"
          />
        </Tooltip>
      ),
    });

    return ncolumns;
  };

  // Custom filter dropdown component for names
  const NamesFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const [searchText, setSearchText] = useState("");
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
      if (selectAll) {
        // Deselect all
        setSelectedKeys([]);
        setSelectAll(false);
      } else {
        // Select all
        const allValues = namesFilter
          .filter((name) => name.value !== "SELECT_ALL_NAMES")
          .map((name) => name.value);
        setSelectedKeys(allValues);
        setSelectAll(true);
      }
    };

    const handleConfirm = () => {
      confirm();
    };

    const handleClear = () => {
      clearFilters();
      setSelectedKeys([]);
      setSelectAll(false);
    };

    const filteredNames = namesFilter.filter(
      (name) =>
        name.value !== "SELECT_ALL_NAMES" &&
        name.text.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="البحث..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ marginBottom: 8 }}>
          <Checkbox
            checked={selectAll}
            onChange={handleSelectAll}
            style={{ fontWeight: "bold" }}
          >
            تحديد الكل
          </Checkbox>
        </div>
        <div style={{ maxHeight: 200, overflow: "auto" }}>
          {filteredNames.map((name) => (
            <div key={name.value} style={{ marginBottom: 4 }}>
              <Checkbox
                checked={selectedKeys.includes(name.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, name.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== name.value)
                    );
                  }
                  setSelectAll(false);
                }}
              >
                {name.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 8, textAlign: "right" }}>
          <Button size="small" onClick={handleClear} style={{ marginRight: 8 }}>
            مسح
          </Button>
          <Button type="primary" size="small" onClick={handleConfirm}>
            تأكيد
          </Button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    fetchAnnualReportData();
  }, [fetchAnnualReportData]);

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    setFilteredInfo(filters);

    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== null) {
          setPAnnTasks(
            annTasks.filter((item) => {
              if (key === "name") {
                return filters[key].includes(item.name);
              }
              return filters[key].includes(item[key]);
            })
          );
        } else {
          setPAnnTasks(annTasks);
        }
      });
    }
  };

  const printReport = () => {
    var report = document.getElementById("ann-report");
    var mywindow = window.open("");
    mywindow.document.write(
      "<html><head><title></title> <style>" +
        PrintFonts.getPrintFontsCSS() +
        "body{font-size:12px;margin:0} " +
        "table{font-size:12px} " +
        "</style>"
    );
    mywindow.document.write('</head><body dir="rtl" style="font-size:12px;" >');
    mywindow.document.write(report.innerHTML);
    mywindow.document.write("</body></html>");

    mywindow.onload = function () {
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    };
  };

  const exportToExcel = (type, fn, dl) => {
    var elt = document.getElementById("ann-report");
    if (elt) {
      var wb = excel.utils.table_to_book(elt, {
        sheet: "sheet1",
        cellStyles: true,
      });
      return dl
        ? excel.write(wb, {
            bookType: type,
            bookSST: true,
            type: "base64",
            cellStyles: true,
          })
        : excel.writeFile(wb, fn || "التقرير السنوي." + (type || "xlsx"), {
            bookSST: true,
            type: "base64",
            cellStyles: true,
          });
    }
  };

  const onChange = (all, date) => {
    setCurrentYear(date);
  };

  var aindex = 1;
  var months = [
    "يناير",
    "فبراير",
    "مارس",
    "إبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];
  var tprevBalance = 0;
  var tcurrBalance = 0;
  var ttransBalance = 0;
  var topBalance = 0;
  var ttotalgBalance = 0;
  var tmonthsBalance = {
    m1: 0,
    m2: 0,
    m3: 0,
    m4: 0,
    m5: 0,
    m6: 0,
    m7: 0,
    m8: 0,
    m9: 0,
    m10: 0,
    m11: 0,
    m12: 0,
  };

  return (
    <Card>
      <div style={{ marginBottom: "10px" }}>
        <div className="discountHeader" style={{ marginBottom: "10px" }}>
          <div className="discountBtn">
            <DatePicker
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
              value={dayjs(currentYear, "YYYY")}
              onChange={onChange}
              placeholder="اختر سنة"
              picker="year"
            />
            <span
              style={{
                marginRight: "12px",
                fontSize: "12px",
                color: "#666",
                maxWidth: "280px",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            >
              عمود «تصفير» يحذف أرصدة واستهلاك الموظف لهذا التقرير فقط (نوع
              إجازة {ANNUAL_REPORT_VAC_ID}).
            </span>
            <Button
              style={{ margin: "0 10px" }}
              onClick={function () {
                exportToExcel("xlsx");
              }}
              type="primary"
            >
              <ExportOutlined /> تصدير
            </Button>
            <Button
              loading={loadReport}
              style={{
                backgroundColor: "#0972B6",
                borderColor: "#0972B6",
                marginLeft: "10px",
              }}
              onClick={function () {
                printReport();
              }}
              type="primary"
            >
              <PrinterOutlined />
            </Button>
          </div>
        </div>
      </div>

      <div className="report-screen-table-wrap">
        <Table
          loading={load}
          columns={getColumnsVac()}
          scroll={{ x: "1500px" }}
          dataSource={pannTasks}
          onChange={handleChange}
        />
      </div>

      <Modal
        title={`تعديل التقرير السنوي${editingRow?.name ? ` - ${editingRow.name}` : ""}`}
        open={isEditModalOpen}
        onCancel={closeEditAnnualRowModal}
        onOk={handleSaveAnnualRowEdit}
        confirmLoading={isSavingEdit}
        okText="حفظ التعديلات"
        cancelText="إلغاء"
        width={860}
      >
        <Form form={editForm} layout="vertical">
          <Space style={{ width: "100%" }} size={12} wrap>
            <Form.Item
              label="مرحل من العام الماضي (دقيقة)"
              name="prev"
              rules={[{ required: true, message: "أدخل قيمة صحيحة" }]}
            >
              <InputNumber min={0} style={{ width: 220 }} />
            </Form.Item>
            <Form.Item
              label="رصيد العام الحالي (دقيقة)"
              name="curr"
              rules={[{ required: true, message: "أدخل قيمة صحيحة" }]}
            >
              <InputNumber min={0} style={{ width: 220 }} />
            </Form.Item>
            <Form.Item
              label="رصيد محول (دقيقة)"
              name="trans"
              rules={[{ required: true, message: "أدخل قيمة صحيحة" }]}
            >
              <InputNumber min={0} style={{ width: 220 }} />
            </Form.Item>
          </Space>

          <div style={{ marginBottom: 8, fontWeight: 600 }}>استهلاك الأشهر (بالدقائق)</div>
          <Space style={{ width: "100%" }} size={12} wrap>
            {months.map((month, index) => (
              <Form.Item
                key={`month-edit-${index + 1}`}
                label={month}
                name={`m${index + 1}`}
                rules={[{ required: true, message: "أدخل قيمة صحيحة" }]}
              >
                <InputNumber min={0} style={{ width: 120 }} />
              </Form.Item>
            ))}
          </Space>
        </Form>
      </Modal>

      <div id="ann-report" style={{ display: "none" }}>
        <div
          style={{
            direction: "rtl",
            fontSize: "12px",
            fontFamily: "Tajawal, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            margin: "0",
          }}
        >
          <table
            class="equal-table"
            style={{
              fontSize: "11px",
              width: " 100%",
              textAlign: " center",
              fontFamily: "Tajawal, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            }}
          >
            <thead>
              <tr style={{ border: "none" }}>
                <th colSpan={21}>
                  <header
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      borderColor: "#000",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1px",
                    }}
                  >
                    <div style={{ width: "20%" }}>
                      <img
                        loading="eager"
                        style={{ width: "250px" }}
                        alt="Logo"
                        src={
                          Env.HOST_SERVER_STORAGE +
                          props.setting.filter(
                            (item) => item.key === "admin.logo"
                          )[0]?.value
                        }
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "60%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        paddingBottom: "10px",
                      }}
                    >
                      <h1
                        style={{
                          fontSize: " 18px",
                          fontWeight: 700,
                          marginBottom: " 5px",
                          margin: "0",
                        }}
                      >
                        كشف السنوية لعام {currentYear}م
                      </h1>
                    </div>
                    <div style={{ width: "20%" }}></div>
                  </header>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      textAlign: "center",
                      fontSize: "14px",
                      borderBottom: "1px solid black",
                    }}
                  ></div>
                </th>
              </tr>

              <tr style={{ color: "#fff", backgroundColor: "#0972B6" }}>
                <th style={{ fontWeight: "100" }}>م</th>
                <th style={{ fontWeight: "100" }}>اسم الموظف</th>
                <th style={{ fontWeight: "100" }}>الوظيفة</th>
                <th style={{ fontWeight: "100", width: "50px" }}>
                  مرحل من العام الماضي
                </th>
                <th style={{ fontWeight: "100", width: "50px" }}>
                  رصيد العام الحالي
                </th>
                <th style={{ fontWeight: "100", width: "50px" }}>رصيد محول</th>
                <th style={{ fontWeight: "100" }}>الافتتاحي</th>

                {months.map((m, ind) => {
                  return (
                    <th
                      class="equal"
                      style={{
                        fontWeight: "100",
                        whiteSpace: "nowrap",
                        transform: "rotate(-180deg)",
                        writingMode: "vertical-rl",
                        height: "30px",
                        width: "30px",
                        maxWidth: "30px",
                      }}
                    >
                      {months[ind]}
                    </th>
                  );
                })}
                <th style={{ fontWeight: "100" }}> الممنوح</th>
                <th style={{ fontWeight: "100" }}> المتبقي</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((item) => {
                var catData = pannTasks.filter(
                  (record) => record.category === item.name
                );
                var prevBalance = 0;
                var currBalance = 0;
                var transBalance = 0;
                var opBalance = 0;
                var totalgBalance = 0;
                var monthsBalance = {
                  m1: 0,
                  m2: 0,
                  m3: 0,
                  m4: 0,
                  m5: 0,
                  m6: 0,
                  m7: 0,
                  m8: 0,
                  m9: 0,
                  m10: 0,
                  m11: 0,
                  m12: 0,
                };
                if (catData.length > 0) {
                  return (
                    <>
                      {catData.map((item) => {
                        prevBalance += item.prev * 1;
                        currBalance += item.curr * 1;
                        transBalance += item.trans * 1;
                        var totalg = 0;
                        var op =
                          Math.round(item.prev) +
                          Math.round(item.curr) +
                          Math.round(item.trans);
                        opBalance += op;

                        tprevBalance += item.prev * 1;
                        tcurrBalance += item.curr * 1;
                        ttransBalance += item.trans * 1;
                        topBalance += op;

                        return (
                          <tr
                            style={{
                              height: " 25px",
                              backgroundColor:
                                aindex % 2 === 0 ? "#e6e6e6" : "#fff",
                            }}
                          >
                            <td style={{ fontWeight: "100" }}>{aindex++}</td>
                            <td style={{ fontWeight: "100" }}>{item.name}</td>
                            <td style={{ fontWeight: "100", width: "100px" }}>
                              {item.job}
                            </td>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.prev / 60) +
                                ":" +
                                Math.round(item.prev % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.curr / 60) +
                                ":" +
                                Math.round(item.curr % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.trans / 60) +
                                ":" +
                                Math.round(item.trans % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(op / 60) + ":" + (op % 60)}
                            </th>
                            {months.map((m, ind) => {
                              var min = item["m" + (ind + 1)] / 60;
                              totalg += min;
                              totalgBalance += min;
                              monthsBalance["m" + (ind + 1)] += min;
                              ttotalgBalance += min;
                              tmonthsBalance["m" + (ind + 1)] += min;
                              return (
                                <td class="equal" style={{ fontWeight: "100" }}>
                                  {parseInt(min / 60) + ":" + (min % 60)}
                                </td>
                              );
                            })}
                            <td style={{ fontWeight: "100" }}>
                              {Math.round((totalg / 60 / 7) * 100) / 100}
                            </td>
                            <th style={{ fontWeight: "100" }}>
                              {Math.round(((op - totalg) / 60 / 7) * 100) / 100}
                            </th>
                          </tr>
                        );
                      })}
                      <tr
                        style={{
                          height: " 25px",
                          color: "#fff",
                          backgroundColor: "#0972B6",
                        }}
                      >
                        <td style={{ fontWeight: "100" }} colSpan={3}>
                          {item.name}
                        </td>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(prevBalance / 60) +
                            ":" +
                            Math.round(prevBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(currBalance / 60) +
                            ":" +
                            Math.round(currBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(transBalance / 60) +
                            ":" +
                            Math.round(transBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(opBalance / 60) + ":" + (opBalance % 60)}
                        </th>
                        {months.map((m, ind) => {
                          var min = monthsBalance["m" + (ind + 1)];
                          return (
                            <td class="equal" style={{ fontWeight: "100" }}>
                              {parseInt(min / 60) + ":" + (min % 60)}
                            </td>
                          );
                        })}
                        <td style={{ fontWeight: "100" }}>
                          {Math.round((totalgBalance / 60 / 7) * 100) / 100}
                        </td>
                        <th style={{ fontWeight: "100" }}>
                          {Math.round(
                            ((opBalance - totalgBalance) / 60 / 7) * 100
                          ) / 100}
                        </th>
                      </tr>
                    </>
                  );
                }
                return null;
              })}
              <tr
                style={{
                  height: " 30px",
                  color: "#fff",
                  backgroundColor: "#0972B6",
                }}
              >
                <td colSpan={3}>{"الإجمالي العام"}</td>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(tprevBalance / 60) +
                    ":" +
                    Math.round(tprevBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(tcurrBalance / 60) +
                    ":" +
                    Math.round(tcurrBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(ttransBalance / 60) +
                    ":" +
                    Math.round(ttransBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(topBalance / 60) + ":" + (topBalance % 60)}
                </th>
                {months.map((m, ind) => {
                  var min = tmonthsBalance["m" + (ind + 1)];
                  return (
                    <td class="equal" style={{ fontWeight: "100" }}>
                      {parseInt(min / 60) + ":" + (min % 60)}
                    </td>
                  );
                })}
                <td style={{ fontWeight: "100" }}>
                  {Math.round((ttotalgBalance / 60 / 7) * 100) / 100}
                </td>
                <th style={{ fontWeight: "100" }}>
                  {Math.round(((topBalance - ttotalgBalance) / 60 / 7) * 100) /
                    100}
                </th>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={21}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "20px",
                      textAlign: "center",
                    }}
                  >
                    {props.setting
                      .filter((item) => item.key === "admin.signs_footer")[0]
                      ?.value.split("\n")
                      .map((sign) => {
                        var sign_position = sign.split(":")[0];
                        var sign_name = sign.split(":")[1];

                        return (
                          <div style={{ width: "50%" }}>
                            <div style={{ fontWeight: "900" }}>
                              {sign_position}
                            </div>
                            {sign_name !== "" && (
                              <div style={{ fontWeight: "500" }}>
                                {sign_name}
                              </div>
                            )}
                          </div>
                        );
                      })}{" "}
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
          <div
            style={{
              marginTop: " 20px",
              width: "85%",
              backgroundColor: "#e6e6e61",
              padding: "5px 0",
              borderTopLeftRadius: " 5px",
              borderBottomLeftRadius: " 5px",
            }}
          >
            <div
              style={{
                backgroundColor: " #0972B6",
                width: " 95%",
                height: " 15px",
                borderTopLeftRadius: " 5px",
                borderBottomLeftRadius: " 5px",
                color: " #fff",
                paddingRight: " 20px",
              }}
            >
              نظام دوام | {new Date().toLocaleString("en-IT")}{" "}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
